import React from "react"
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

const Breadcrumb = props => {

  const itemLength = (props.breadcrumbItems || []).length || 1;

  return (
    <div className="page-title-box pb-0">
      <h4>{props.title}</h4>

      <ol className="breadcrumb m-0">
        {(props.breadcrumbItems || []).map((item, key) =>
          (key + 1) === itemLength ? (
            <li key={key} className="breadcrumb-item active">
              {item.title}
            </li>
          ) : (
            <li key={key} className="breadcrumb-item">
              <Link to={item.link}>{item.title}</Link>
            </li>
          )
        )}
      </ol>
    </div>
  );
};

const mapStatetoProps = state => {
  const Layout = state.Layout;
  const BreadcrumbData = state.Breadcrumb;
  return {
    layoutType: Layout.layoutType,
    title: BreadcrumbData.title,
    breadcrumbItems: BreadcrumbData.breadcrumbItems
  };
};

export default connect(mapStatetoProps, {})(Breadcrumb);
